import { default as useCompanyInvitations } from "./useCompanyInvitations";
export default {
  useCompanyInvitations,
};
